const STATUS_APPROVED: number = 8;
const STATUS_REJECTED: number = 7;
const STATUS_PENDING: number = 5;

export interface ISubmitRequestExtensionData {
    evaluationSk?: string;
    reviewDate?: Date;
    extensionDays?: string;
    reason?: { id?: string };
    otherReason?: string;
    status?: number;
    extensionDaysApproved?: number;
    newDueByDate?: Date;
    reasonForRejection?: { id?: number };
    otherReasonForRejection?: string;
    isApproved?: boolean;
    evalutionName?: string;
    dueDate?: string;
    asstmtRejectionReasonOther?: string;
    asstmtRejectionReason?: { id?: number };
    asstmtReviewDate?: string;
    asstmtReviewBy?: string;
    asstmtReviewApproved?: boolean;
    nycId?: string;
}

export class SubmitRequestExtensionModel {
    evaluationSk: string;
    reviewDate: Date;
    extensionDays: string;
    reason: string;
    otherReason: string;
    status: number;
    actionType: number;
    extensionDaysApproved: number;
    newDueByDate: Date;
    reasonForRejection: number;
    otherReasonForRejection: string;
    isApproved: boolean;
    evalutionName: string;
    dueDate: string;
    asstmtRejectionReasonOther: string;
    asstmtRejectionReason: number;
    asstmtReviewDate: string;
    asstmtReviewBy: string
    asstmtReviewApproved: boolean;
    nycId: string
    constructor(data: Partial<ISubmitRequestExtensionData>) {
        this.evaluationSk = data?.evaluationSk;
        this.reviewDate = data?.reviewDate;
        this.extensionDays = data?.extensionDays;
        this.reason = data?.reason?.id;
        this.otherReason = data?.otherReason;
        this.status = data?.status === STATUS_APPROVED ? STATUS_APPROVED : data?.status === STATUS_REJECTED ? STATUS_REJECTED : STATUS_PENDING;
        this.extensionDaysApproved = data?.extensionDaysApproved;
        this.newDueByDate = data?.newDueByDate;
        this.reasonForRejection = data?.reasonForRejection?.id;
        this.otherReasonForRejection = data?.otherReasonForRejection;
        this.isApproved = data?.isApproved;
        this.evalutionName = data?.evalutionName;
        this.dueDate = data?.dueDate
        this.asstmtRejectionReasonOther = data?.asstmtRejectionReasonOther;
        this.asstmtRejectionReason = data?.asstmtRejectionReason?.id;
        this.asstmtReviewDate = data?.asstmtReviewDate;
        this.asstmtReviewBy = data?.asstmtReviewBy;
        this.asstmtReviewApproved = data?.asstmtReviewApproved;
        this.nycId = data?.nycId;

    }

    get id(): string {
        return this.evaluationSk
    }
}